import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store';
//import HomeV2 from '@/views/HomeV2.vue';
import Home from '@/views/Home.vue';
import Sobre from '@/views/Sobre.vue';

Vue.use(VueRouter);

const routes = [
    {
        path: '',
        name: 'home',
        component: Home,
        meta: {
            authRequired: true,
            allowedUserTypes: [
                'superAdminRecuperi',
                'superAdminGeral',
                'admin',
                'basic'
            ]
        }
    },
    {
        path: '/sobre',
        name: 'sobre',
        component: Sobre,
        meta: {
            authRequired: true,
            allowedUserTypes: [
                'superAdminRecuperi',
                'superAdminGeral',
                'admin',
                'basic'
            ]
        }
    },
    {
        path: '/consulta-titulos',
        name: 'consulta-titulos',
        component: () => import('@/views/ConsultaTitulos.vue'),
        meta: {
            authRequired: true,
            allowedUserTypes: [
                'superAdminRecuperi',
                'superAdminGeral',
                'admin',
                'basic',
                'lite',
                'liteRo'
            ]
        }
    },
    {
        path: '/detalhe-titulo',
        name: 'detalhe-titulo',
        component: () => import('@/views/DetalheTitulo.vue'),
        meta: { authRequired: true, allowedUserTypes: ['superAdminRecuperi', 'superAdminGeral', 'admin', 'basic', 'lite', 'liteRo'] }
    },
    {
        path: '/download-instrumentos',
        name: 'download-instrumentos',
        component: () => import('@/views/InstrumentosEmMassa.vue'),
        meta: {
            authRequired: true,
            allowedUserTypes: [
                'superAdminRecuperi',
                'superAdminGeral',
                'admin',
                'basic',
                'lite',
                'liteRo'
            ]
        }
    },
    {
        path: '/listar-agrupadores',
        name: 'listar-agrupadores',
        component: () => import('@/views/ListarAgrupadores.vue'),
        meta: {
            authRequired: true,
            allowedUserTypes: [
                'superAdminRecuperi',
                'superAdminGeral',
                'admin'
            ],
            blockAgrupadorUser: true
        }
    },
    {
        path: '/upload-titulos',
        name: 'upload-titulos',
        component: () => import('@/views/UploadTitulos.vue'),
        meta: {
            authRequired: true,
            allowedUserTypes: [
                'superAdminRecuperi',
                'superAdminGeral',
                'admin',
                'basic'
            ]
        }
    },
    {
        path: '/revisao-interna',
        name: 'revisao-interna',
        component: () => import('@/views/RevisaoInterna.vue'),
        meta: { authRequired: true, allowedUserTypes: ['superAdminRecuperi'] }
    },
    {
        path: '/listar-usuarios',
        name: 'ListarUsuarios',
        component: () => import('@/views/ListarUsuarios.vue'),
        meta: {
            authRequired: true,
            allowedUserTypes: [
                'superAdminRecuperi',
                'superAdminGeral',
                'admin'
            ],
            blockAgrupadorUser: true
        }
    },
    {
        path: '/detalhe-oferta',
        name: 'DetalheOferta',
        component: () => import('@/views/DetalheOfertaView.vue'),
        meta: { authRequired: true, allowedUserTypes: ['superAdminRecuperi'] }
    },
    {
        path: '/login',
        name: 'login',
        component: () => {
            const hostname = window.location.hostname;
            const pathname = window.location.pathname;

            if (
                hostname.includes('equifax') ||
                pathname.includes('login-bvs')
            ) {
                return import('@/views/LoginBvs.vue');
            }
            return import('@/views/Login.vue');
        },
        meta: { disallowAuthed: true }
    },
    {
        path: '/login-bvs',
        name: 'login Bvs',
        component: () => import('@/views/LoginBvs.vue'),
        meta: { disallowAuthed: true }
    },
    {
        path: '/listar-cartorios',
        name: 'listar-cartorios',
        component: () => import('@/views/ListarCartorios.vue'),
        meta: { authRequired: true, allowedUserTypes: ['superAdminRecuperi'] }
    },
    {
        path: '/financeiro/repasse',
        name: 'FinanceiroRepasse',
        component: () => import('@/views/FinanceiroRepasse.vue'),
        meta: {
            authRequired: true,
            allowedUserTypes: [
                'superAdminRecuperi',
                'superAdminGeral',
                'admin',
                'basic'
            ]
        }
    },
    {
        path: '/esqueci-senha',
        name: 'esqueci senha',
        component: () => import('@/views/EsqueciSenha.vue')
    },
    {
        path: '/relatorios-faturamento',
        name: 'Relatórios Faturamento',
        component: () => import('@/views/RelatorioFaturamento.vue'),
        meta: {
            authRequired: true,
            allowedUserTypes: ['superAdminRecuperi', 'admin']
        }
    },
    {
        path: '/ajustes-mensageria',
        name: 'Ajustes Mensageria',
        component: () => import('@/views/ConfiguracoesMensageria.vue'),
        meta: {
            authRequired: true,
            allowedUserTypes: [
                'superAdminRecuperi',
                'superAdminGeral',
                'admin',
                'basic'
            ]
        }
    },
    {
        path: '/relatorios-mensageria',
        name: 'Relatórios Mensageria',
        component: () => import('@/views/RelatoriosMensageria.vue'),
        meta: {
            authRequired: true,
            allowedUserTypes: [
                'superAdminRecuperi',
                'superAdminGeral',
                'admin',
                'basic',
                'lite',
                'liteRo'
            ]
        }
    },
    {
        path: '/listar-apresentantes',
        name: 'Listar Apresentantes',
        component: () => import('@/views/ListarApresentantes.vue'),
        meta: {
            authRequired: true,
            allowedUserTypes: ['superAdminRecuperi', 'superAdminGeral']
        }
    },
    {
        path: '/gerenciamento-login-social',
        name: 'Gerenciamento de Login Social',
        component: () => import('@/views/GerenciamentoLoginSocial.vue'),
        meta: {
            authRequired: true,
            allowedUserTypes: ['superAdminRecuperi', 'superAdminGeral', 'admin']
        }
    },
    {
        path: '/trocar-apresentante',
        name: 'Mudar Apresentante',
        component: () => import('@/views/TrocarApresentante.vue'),
        meta: {
            authRequired: true,
            allowedUserTypes: ['superAdminRecuperi', 'superAdminGeral']
        }
    },
    {
        path: '/selecionar-acesso',
        name: 'Selecionar Acesso',
        component: () => import('@/views/SelecionarAcesso.vue'),
        meta: { authRequired: true, allowedUserTypes: ['socialAccess'] }
    },
    {
        path: '/enviar-sms',
        name: 'Enviar SMS',
        component: () => import('@/views/ListarSms.vue'),
        meta: { authRequired: true, allowedUserTypes: ['superAdminRecuperi'] }
    },
    {
        path: '/enviar-email',
        name: 'Enviar Email',
        component: () => import('@/views/ListarEmail.vue'),
        meta: { authRequired: true, allowedUserTypes: ['superAdminRecuperi'] }
    },
    {
        path: '/campanhas-whatsapp',
        name: 'WhatsApp',
        component: () => import('@/views/ListarWhatsapp.vue'),
        meta: { authRequired: true, allowedUserTypes: ['superAdminRecuperi'] }
    },
    {
        path: '/relatorios/campanhas-whatsapp',
        name: 'Relatórios de Campanhas WhatsApp',
        component: () => import('@/views/RelatorioCampanhasWhatsapp.vue'),
        meta: { authRequired: true, allowedUserTypes: ['superAdminRecuperi'] }
    },
    {
        path: '/relatorios/campanhas-sms',
        name: 'Relatórios de Campanhas SMS',
        component: () => import('@/views/RelatorioCampanhasSMS.vue'),
        meta: { authRequired: true, allowedUserTypes: ['superAdminRecuperi'] }
    },
    {
        path: '/pesquisa-avancada',
        name: 'Pesquisa Avançada',
        component: () => import('@/views/PesquisaAvancada.vue'),
        meta: { authRequired: true, allowedUserTypes: ['superAdminRecuperi'] }
    },
    {
        path: '/listar-comarcas',
        name: 'Listar Comarcas',
        component: () => import('@/views/ListarComarcas.vue'),
        meta: { authRequired: true, allowedUserTypes: ['superAdminRecuperi'] }
    },
    {
        path: '/cancelamento-em-massa',
        name: 'Cancelamento em massa',
        component: () => import('@/views/CancelamentoEmMassaV2.vue'),
        meta: { authRequired: true, allowedUserTypes: ['superAdminRecuperi'] }
    },
    {
        path: '/anuencia-em-massa',
        name: 'Anuência em massa',
        component: () => import('@/views/AnuenciaEmMassaV2.vue'),
        meta: {
            authRequired: true,
            allowedUserTypes: ['superAdminRecuperi', 'superAdminGeral', 'admin']
        }
    },
    {
        path: '/desistencia-em-massa',
        name: 'Desistência em massa',
        component: () => import('@/views/DesistenciaEmMassaV2.vue'),
        meta: { authRequired: true, allowedUserTypes: ['superAdminRecuperi'] }
    },
    {
        path: '/agrupador-em-massa',
        name: 'Agrupador em massa',
        component: () => import('@/views/AgrupadorEmMassaV2.vue'),
        meta: {
            authRequired: true,
            allowedUserTypes: ['superAdminRecuperi', 'superAdminGeral', 'admin']
        }
    },
    {
        path: '/manutencao-devedor-codevedor',
        name: 'Manutenção de Devedor/Codevedor',
        component: () => import('@/views/ManutencaoDevedorCoodevedor.vue'),
        meta: {
            authRequired: true,
            allowedUserTypes: ['superAdminRecuperi', 'superAdminGeral', 'admin']
        }
    },
    {
        path: '/upload-em-massa',
        name: 'Upload em massa',
        component: () => import('@/views/UploadEmMassa.vue'),
        meta: {
            authRequired: true,
            allowedUserTypes: ['superAdminRecuperi', 'superAdminGeral', 'admin']
        }
    },
    {
        path: '/mapa-de-status',
        name: 'Mapa de Status',
        component: () => import('@/views/MapaStatus.vue'),
        meta: {
            authRequired: true,
            allowedUserTypes: [
                'superAdminRecuperi',
                'superAdminGeral',
                'admin',
                'basic'
            ]
        }
    },
    {
        path: '/fluxo-de-protesto',
        name: 'Fluxo de Protesto',
        component: () => import('@/views/FluxoProtesto.vue'),
        meta: {
            authRequired: true,
            allowedUserTypes: [
                'superAdminRecuperi',
                'superAdminGeral',
                'admin',
                'basic'
            ]
        }
    },
    {
        path: '/manual-do-protesto',
        name: 'Manual do Protesto',
        component: () => import('@/views/ManualProtesto.vue'),
        meta: {
            authRequired: true,
            allowedUserTypes: [
                'superAdminRecuperi',
                'superAdminGeral',
                'admin',
                'basic'
            ]
        }
    },
    {
        path: '/manual-do-usuario',
        name: 'Manual do Usuário',
        component: () => import('@/views/ManualUsuario.vue'),
        meta: {
            authRequired: true,
            allowedUserTypes: [
                'superAdminRecuperi',
                'superAdminGeral',
                'admin',
                'basic'
            ]
        }
    },
    {
        path: '/faq',
        name: 'Dúvidas Frequentes',
        component: () => import('@/views/Faq.vue'),
        meta: {
            authRequired: true,
            allowedUserTypes: [
                'superAdminRecuperi',
                'superAdminGeral',
                'admin',
                'basic'
            ]
        }
    },
    {
        path: '/ofertas-globais',
        name: 'Ofertas Globais',
        component: () => import('@/views/OfertasGlobais.vue'),
        meta: { authRequired: true, allowedUserTypes: ['superAdminRecuperi'] }
    },
    {
        path: '/relatorios/ofertas-globais',
        name: 'Relatórios de Ofertas Globais',
        component: () => import('@/views/RelatorioOfertasGlobais.vue'),
        meta: { authRequired: true, allowedUserTypes: ['superAdminRecuperi'] }
    },
    {
        path: '/relatorios/ofertas-titulo',
        name: 'Relatórios de OfertasTítulo',
        component: () => import('@/views/RelatorioOfertasTitulo.vue'),
        meta: { authRequired: true, allowedUserTypes: ['superAdminRecuperi'] }
    },
    {
        path: '/ofertas-titulo',
        name: 'Ofertas Tïtulo',
        component: () => import('@/views/OfertasTitulo.vue'),
        meta: { authRequired: true, allowedUserTypes: ['superAdminRecuperi'] }
    },
    {
        path: '/renegociacoes',
        name: 'Listar Renegociações',
        component: () => import('@/views/ListarRenegociacoes.vue'),
        meta: { authRequired: true, allowedUserTypes: ['superAdminRecuperi'] }
    },
    {
        path: '/manual-de-upload',
        name: 'Manual de Upload',
        component: () => import('@/components/ManualUpload.vue'),
        meta: {
            authRequired: true,
            allowedUserTypes: [
                'superAdminRecuperi',
                'superAdminGeral',
                'admin',
                'basic'
            ]
        }
    },
    {
        path: '/documentacao-api',
        name: 'Documentação de API',
        component: () => import('@/components/ManualApi.vue'),
        meta: {
            authRequired: true,
            allowedUserTypes: [
                'superAdminRecuperi',
                'superAdminGeral',
                'admin',
                'basic'
            ]
        }
    },
    {
        path: '/emolumentos',
        name: 'Emolumentos',
        component: () => import('@/views/Emolumentos.vue'),
        meta: { authRequired: true, allowedUserTypes: ['superAdminRecuperi'] }
    },
    {
        path: '/falha-retornos',
        name: 'FalhaRetornos',
        component: () => import('@/views/FalhaRetornos.vue'),
        meta: { authRequired: true, allowedUserTypes: ['superAdminRecuperi'] }
    },
    {
        path: '/webhooks',
        name: 'MonitoramentoWebhooks',
        component: () => import('@/views/MonitoramentoWebhooks.vue'),
        meta: {
            authRequired: true,
            allowedUserTypes: [
                'superAdminRecuperi',
                'superAdminGeral',
                'admin',
                'basic',
                'lite',
                'liteRo'
            ]
        }
    },
    {
        path: '/manutencao-especie-titulos',
        name: 'ManutencaoEspecieTitulos',
        component: () => import('@/views/ManutencaoEspecieTitulos.vue'),
        meta: { authRequired: true, allowedUserTypes: ['superAdminRecuperi'] }
    },
    {
        path: '/titulos-problematicos',
        name: 'TitulosProblematicos',
        component: () => import('@/views/TitulosProblematicos.vue'),
        meta: { authRequired: true, allowedUserTypes: ['superAdminRecuperi'] }
    },
    {
        path: '/minha-conta/:action?',
        name: 'MinhaConta',
        component: () => import('@/views/MinhaConta.vue'),
        meta: {
            authRequired: true,
            allowedUserTypes: [
                'superAdminRecuperi',
                'superAdminGeral',
                'admin',
                'basic',
                'lite',
                'liteRo'
            ]
        }
    },
    {
        path: '*',
        component: Home,
        meta: {
            authRequired: true,
            allowedUserTypes: [
                'superAdminRecuperi',
                'superAdminGeral',
                'admin',
                'basic',
                'lite',
                'liteRo'
            ]
        }
    },
    {
        path: '/acesso-negado',
        component: () => import('@/views/AcessoNegado.vue'),
        meta: {
            authRequired: true,
            allowedUserTypes: [
                'superAdminRecuperi',
                'superAdminGeral',
                'admin',
                'basic',
                'lite',
                'liteRo'
            ]
        }
    },
    {
        path: '/cancelamento-negociacao',
        name: 'Cancelamento de Negociação em Lote',
        component: () => import('@/views/CancelamentoNegociacaoEmMassa.vue'),
        meta: { authRequired: true, allowedUserTypes: ['superAdminRecuperi'] }
    },
    {
        path: '/titulo-em-revisao-em-massa',
        name: 'Títulos em Revisão',
        component: () => import('@/views/TitulosEmRevisao.vue'),
        meta: { authRequired: true, allowedUserTypes: ['superAdminRecuperi'] }
    },
    {
        path: '/cessao-titulos',
        name: 'Cessão de Títulos',
        component: () => import('@/views/CessaoTitulosV2.vue'),
        meta: { authRequired: true, allowedUserTypes: ['superAdminRecuperi'] }
    },
    {
        path: '/gerenciamento-divulgacoes',
        name: 'Gerenciamento de Divulgações',
        component: () => import('@/views/GerenciamentoDivulgacoes.vue'),
        meta: {
            authRequired: true,
            allowedUserTypes: ['superAdminRecuperi']
        }
    }
];

const router = new VueRouter({
    routes,
    mode: 'history',
    base: process.env.BASE_URL
});

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.authRequired)) {
        if (!store.state.isAuthenticated) {
            next({
                path: '/login'
            });
        } else if (!to.meta.allowedUserTypes.includes(store.getters.userType)) {
            // Usuário autenticado, mas não tem permissão para esta rota
            next({
                path: '/acesso-negado'
            });
        } else {
            if (
                typeof to.meta.blockAgrupadorUser !== 'undefined' &&
                to.meta.blockAgrupadorUser &&
                store.getters.agrupadorUsuario
            ) {
                next({
                    path: '/acesso-negado'
                });
            }

            if (
                to.path === '/webhooks' &&
                store.getters.getSuperUser !== 1 &&
                !store.getters.callbackUrlEndpoint
            ) {
                next({
                    path: '/acesso-negado'
                });
            }

            if (store.getters.agrupadorUsuario && to.path == '/') {
                next({
                    path: '/consulta-titulos'
                });
            }

            // Usuário autenticado e tem permissão
            next();
        }
    } else {
        if (store.state.isAuthenticated && to.path === '/login') {
            // Usuário autenticado tentando retornar para a tela de login
            next({
                path: '/consulta-titulos'
            });
            return;
        }

        // Rota pública, permita o acesso
        next();
    }
});

export default router;
